import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { IInFoResponse } from '@web-nx-ng-tsc/campaign-shared-data-access';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Component({
  selector: 'ecoupon-shared-ui-lip-ecoupon-information',
  imports: [MatButtonModule],
  templateUrl: './lip-ecoupon-information.component.html',
  styleUrl: './lip-ecoupon-information.component.scss',
})
export class LipEcouponInformationComponent {
  @Input() set data(value: IInFoResponse) {
    this.dataSignal.set(value);
    this.loggingService.log('data', value);
  }

  @Output() emitInformation = new EventEmitter();

  private readonly loggingService = inject(LoggingService);

  dataSignal = signal<IInFoResponse>({
    img: '',
    message: '',
  });
}
